import http from './httpRequest.js'

class AdminApi {
}

// 系统配置
AdminApi.prototype.getConfig = function () {
	return http({ url: '/admin/config', method: 'get' })
}
AdminApi.prototype.saveConfig = function (data) {
	return http({ url: '/admin/config', method: 'post', data: data })
}
AdminApi.prototype.testEmail = function (to) {
	return http({ url: '/admin/config/testEmail?to=' + encodeURIComponent(to), method: 'post' })
}

// 用户管理
AdminApi.prototype.listUsers = function (pageNo, pageSize, keyword) {
	return http({
		url: '/admin/user/list',
		method: 'get',
		params: { pageNo: pageNo, pageSize: pageSize, keyword: keyword }
	})
}
AdminApi.prototype.banUser = function (userId, reason) {
	return http({ url: '/admin/user/ban?userId=' + userId + '&reason=' + encodeURIComponent(reason || ''), method: 'post' })
}
AdminApi.prototype.unbanUser = function (userId) {
	return http({ url: '/admin/user/unban?userId=' + userId, method: 'post' })
}
AdminApi.prototype.deleteUser = function (userId) {
	return http({ url: '/admin/user/' + userId, method: 'delete' })
}
AdminApi.prototype.resetPassword = function (userId, newPassword) {
	return http({ url: '/admin/user/resetPassword?userId=' + userId + '&newPassword=' + encodeURIComponent(newPassword), method: 'post' })
}

// 群聊管理
AdminApi.prototype.listGroups = function (keyword) {
	return http({ url: '/admin/group/list', method: 'get', params: { keyword: keyword } })
}
AdminApi.prototype.dissolveGroup = function (groupId) {
	return http({ url: '/admin/group/dissolve?groupId=' + groupId, method: 'post' })
}

// 数据清理
AdminApi.prototype.cleanPrivate = function (userId) {
	return http({ url: '/admin/data/private?userId=' + userId, method: 'delete' })
}
AdminApi.prototype.cleanGroup = function (groupId) {
	return http({ url: '/admin/data/group?groupId=' + groupId, method: 'delete' })
}
AdminApi.prototype.cleanAll = function () {
	return http({ url: '/admin/data/all', method: 'delete' })
}

// 敏感词
AdminApi.prototype.listSensitive = function () {
	return http({ url: '/admin/sensitive/list', method: 'get' })
}

// 实名审核
AdminApi.prototype.listRealname = function (pageNo, pageSize, status) {
	return http({
		url: '/admin/realname/list',
		method: 'get',
		params: { pageNo: pageNo, pageSize: pageSize, status: status }
	})
}
AdminApi.prototype.auditRealname = function (id, pass, reason) {
	return http({
		url: '/admin/realname/audit?id=' + id + '&pass=' + pass + '&reason=' + encodeURIComponent(reason || ''),
		method: 'post'
	})
}
AdminApi.prototype.realnameImage = function (id, side) {
	return http({ url: '/admin/realname/image/' + id + '/' + side, method: 'get' })
}
AdminApi.prototype.addSensitive = function (word) {
	return http({ url: '/admin/sensitive/add?word=' + encodeURIComponent(word), method: 'post' })
}
AdminApi.prototype.deleteSensitive = function (id) {
	return http({ url: '/admin/sensitive/' + id, method: 'delete' })
}
AdminApi.prototype.updateSensitive = function (id, content, enabled) {
	let params = { id: id }
	if (content !== undefined && content !== null) params.content = content
	if (enabled !== undefined && enabled !== null) params.enabled = enabled
	return http({ url: '/admin/sensitive', method: 'put', params: params })
}


// 官网站点配置
AdminApi.prototype.getSite = function () {
	return http({ url: '/admin/site', method: 'get' })
}
AdminApi.prototype.saveSite = function (data) {
	return http({ url: '/admin/site', method: 'put', data: data })
}

export default AdminApi
